import { match, P } from 'ts-pattern';

import {
    type GenerationStatus,
    type GenerationStepStatus,
    generationStepStatus,
    generatorStepsConfig,
} from '@/entities/session';

export function getStepStatus(
    targetStatus: GenerationStatus,
    currentStatus: GenerationStatus | null | undefined,
): GenerationStepStatus {
    if (!currentStatus) return generationStepStatus.IN_PROGRESS;

    const targetIndex = generatorStepsConfig.findIndex((config) => config.key === targetStatus);
    const currentIndex = generatorStepsConfig.findIndex((config) => config.key === currentStatus);

    return match(currentIndex - targetIndex)
        .with(
            P.when((diff) => diff > 0),
            () => generationStepStatus.COMPLETED,
        )
        .with(
            P.when((diff) => diff < 0),
            () => generationStepStatus.IDLE,
        )
        .otherwise(() => generationStepStatus.IN_PROGRESS);
}
